import React from 'react'
import $ from 'jquery'
// import ReactDOM from 'react-dom'

import '../utility/csrf'
import GlobalBanner from '../common/globalBanner'
import LinnerDiv from '../common/lineDiv'
import SubHeader from '../common/subHeader'
import Note from '../common/note'
import PPLogIn from '../common/pPLogIn'
import Amount from '../common/amount'
import OrLine from '../common/orLine'
import GuestForm from '../guest/guestForm'
import PayCreditOrDebit from '../guest/payCreditOrDebit'
import { i18n } from 'react-i18n'

import { handleLogIn, handleTokenReuse } from '../utility/helper'

import templateData from '../utility/getTemplateData'
import appStore from '../stores/AppStore'
import appActions from '../actions/AppActions'
import AppDispatcher from '../dispatcher/AppDispatcher'
import * as FPT from '../utility/fpt'

export default React.createClass({

	mixins: [i18n('routes/guest')],

	getInitialState() {
		return {
			amountAmount: appStore.getDonationAmount(),
			amountSymbol: appStore.getDonationSymbol(),
			amountCode: appStore.getDonationCode(),
			hasLogo: templateData.hasLogo,
			subHeaderLabel: templateData.donationName,
			isEditable: templateData.donationAmountEditable,
			guestRedirectUrl: templateData.guestRedirectUrl,
			showServiceErrors: false,
			errorMesages: []
		};
	},

	componentDidMount() {
		// Only adding page name, if "fptPageName=landing", in other cases track event will be triggered when template is loaded.
		if (templateData.fptPageName === 'landing') {
			FPT.trackPage('main:donate:wps:guest:guestform', 'main:donate:wps:guest:guestform:web::')
		}

		$('.spinneroverlay').hide();

		handleTokenReuse();

		let self = this

		// Handles serverside errors
		AppDispatcher.register(function(payload) {

			 if (payload.action && (payload.action.actionType === 'UPDATE_SERVER_ERRORS')) {

				let errorMesages = payload.action.item.serverErrors
				let showServiceErrors = errorMesages.length > 0

				self.setState({
					showServiceErrors: showServiceErrors,
					errorMesages: errorMesages
				});

				if (showServiceErrors) {
					let errorEl = $('.service_error_holder:visible')
					setTimeout(function() {
						$('html, body').animate({
							scrollTop: errorEl.offset().top
						}, 1000);
					}, 10)
				}
			 }
		});
	},

	componentWillUnmount() {},

	getFPTDATA() {
		return {
			amount: appStore.getDonationAmount(),
			code: appStore.getDonationCode(),
			symbol: appStore.getDonationSymbol()
		}
	},

	handleLogIn() {
		if (appStore.getDonationAmount()) {
			FPT.trackLinkClickWithData('guestLogIn', this.getFPTDATA())
		}
		handleLogIn()
	},

	handleAmountChange(amount) {
		appActions.changeAmount({ amount: amount });
	},

	render() {
		let errorgeneric = this.i18n('error.generic')
		return (
			<div className="donate_wrapper">
				<div className="container">
					{this.state.showServiceErrors ?
						<div className="col-xs-12 col-sm-12 col-md-12 service_error_holder">
							{this.state.errorMesages.map(function(message) {
								return <div  className="row" key={message.key}>
												<p className="col-xs-1 col-sm-1 col-md-1"><span className="icon icon-small icon-critical-small" aria-hidden="true"></span></p>
												<p className="col-xs-11 col-sm-11 col-md-11"style={{ paddingLeft: '5px', marginTop: '5px' }}>{message.value}</p>
								</div>;
							})}
						</div> : null}
					<GlobalBanner
						logourl={this.state.logourl}/>
					<SubHeader
						label={this.state.subHeaderLabel}/>
					<form id="guestForm" noValidate>
						<Amount
							amount={this.state.amountAmount}
							symbol={this.state.amountSymbol}
							code={this.state.amountCode}
							isEditable={this.state.isEditable}
							handleAmount={this.handleAmountChange}/>
						<p className="err_update_amount text-center">{errorgeneric}</p>
						<LinnerDiv />
						{templateData.charityNoteEnabled ? <Note /> : null}
						<PPLogIn
							handleLogIn={this.handleLogIn}/>
						<OrLine />
						<PayCreditOrDebit />
						<GuestForm />
					</form>
				</div>
			</div>
		)
	}
})



// WEBPACK FOOTER //
// ./guest/guest.js